import { Typography } from '@mui/material';
import { theme } from '../../../../styles';

export const PostHeroTitle = ({ title }) => (
  <Typography
    variant="h1"
    className="title"
    sx={{
      color: theme?.palette?.common.white,
      fontSize: '1.375rem',
      lineHeight: '1.625rem',
      fontWeight: '600',
      [theme?.breakpoints?.up('sm')]: {
        maxWidth: '66.67%',
        paddingRight: '1rem',
      },
      [theme?.breakpoints?.up('xmd')]: {
        fontSize: '1.625rem',
        lineHeight: '1.875rem',
      },
      [theme?.breakpoints?.up('xlg')]: {
        paddingRight: '2rem',
      },
    }}
  >
    {title}
  </Typography>
);
